const productData = {
  Id: 0,
  boxLines: [
    {
      rowList: [{ title: "型号：", banding: "PartNo", value: "LKSADJG" }]
    },
    {
      rowList: [
        { title: "品牌：", banding: "Brand", value: "HJASKDH" },
        { title: "名称：", banding: "ProductName", value: "HKJASDHFDS" }
      ]
    },
    {
      rowList: [
        { title: "关税率：", banding: "TariffRate", value: "12%" },
        { title: "增值税率：", banding: "VatRate", value: "13%" }
      ]
    },
    {
      rowList: [
        { title: "创建日期：", banding: "CreatedAt", value: "2020-06-20", dataType: "Date" }
      ]
    },
    {
      rowList: [
        {
          title: "监管条件： ",
          banding: "Supervision",
          value: "香港正能量入仓,通关状态(正常/异常),深证正能量送货,下单审核"
        }
      ]
    }
  ]
};

const customsProductData = {
  Id: 0,
  boxLines: [
    {
      rowList: [{ title: "型号：", banding: "PartNo", value: "" }]
    },
    {
      rowList: [
        { title: "品牌：", banding: "Brand", value: "" },
        { title: "名称：", banding: "ProductName", value: "" }
      ]
    },
    {
      rowList: [
        { title: "报关时间：", banding: "CustomsAt", value: "", dataType: "Date" },
        { title: "产地：", banding: "RegionName", value: "" }
      ]
    },
    {
      rowList: [
        { title: "关税率：", banding: "TariffRate", value: "" },
        { title: "增值税率：", banding: "VatRate", value: "" }
      ]
    },
    {
      rowList: [
        { title: "商检：", banding: "InspectionType", value: "", dataType: "Date" }
      ]
    }
  ]
};
export { productData, customsProductData };
